import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import gallery_pic from '../assets/images/gallery_pic.jpg';
import shey_pic from '../assets/images/shey_pic.jpg';
import about_me_inset from '../assets/images/about_me_inset.jpg';
import for_sale_inset_pic from '../assets/images/for_sale_inset_pic.jpg';
import custom_orders_header from '../assets/images/custom_orders_header.jpg';

function MainFeaturedPost(props) {
  const { post } = props;
  const aboutMeBackgroundURL = './images/about_me.jpg';
  const backgroundURL = './images/arcing_wave_background.jpg';
  const backgroundURLOcean = './images/ocean_tide.jpg';
  const contactBackgroundURL = './images/contact_background.jpg';
  const receiptBackgroundURL = './images/receipt_background.jpg';
  const customOrdersBackgroundURL = './images/custom_orders_background.jpg';
  const forSaleBackgroundURL = './images/for_sale_background.jpg';

  const getBackgroundImage = () => {
    if (post.title === 'About Me') {
      return `url(${aboutMeBackgroundURL})`;
    } else if (post.title === 'Gallery') {
      return `url(${backgroundURLOcean})`;
    } else if (post.title === `Shey's Craft Room`) {
      return `url(${backgroundURL})`;
    } else if (post.title === `Receipt`) {
      return `url(${receiptBackgroundURL})`;
    } else if (post.title === `Contact`) {
      return `url(${contactBackgroundURL})`;
    } else if (post.title === `Custom Orders`) {
      return `url(${customOrdersBackgroundURL})`;
    } else if (post.title === `For Sale`) {
      return `url(${forSaleBackgroundURL})`;
    }
  };

  const getInsetImage = () => {
    if (post.title === 'Gallery') {
      return (
        <img
          src={gallery_pic}
          alt={'gallery pic'}
          width={window.innerWidth > 700 ? 450 : 300}
          style={{
            borderRadius: '100%',
            marginTop: 0,
            border: '4px solid #ffff66',
          }}
        />
      );
    } else if (post.title === `Shey's Craft Room`) {
      return (
        <img
          src={shey_pic}
          alt={'gallery pic'}
          width={window.innerWidth > 700 ? 450 : 300}
          style={{
            borderRadius: '100%',
            marginTop: 0,
            border: '4px solid #ffff66',
          }}
        />
      );
    } else if (post.title === `About Me`) {
      return (
        <img
          src={about_me_inset}
          alt={'gallery pic'}
          width={window.innerWidth > 600 ? 350 : 200}
          style={{
            borderRadius: '100%',
            marginTop: 0,
            border: '4px solid #ffff66',
          }}
        />
      );
    } else if (post.title === `Receipt`) {
      return;
    } else if (post.title === `Custom Orders`) {
      return (
        <img
          src={custom_orders_header}
          alt={'gallery pic'}
          width={window.innerWidth > 600 ? 400 : 200}
          style={{
            borderRadius: '100%',
            marginTop: 0,
            border: '4px solid #ffff66',
          }}
        />
      );
    } else if (post.title === `Contact`) {
      return;
    } else if (post.title === `For Sale`) {
      return (
        <img
          src={for_sale_inset_pic}
          alt={'gallery pic'}
          width={window.innerWidth > 600 ? 300 : 200}
          style={{
            borderRadius: '100%',
            marginTop: 0,
            border: '4px solid #ffff66',
          }}
        />
      );
    }
  };
  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 10,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height:
          post.title === 'Receipt' ||
          post.title === 'About Me' ||
          post.title === 'Custom Orders' ||
          post.title === 'Gallery' ||
          post.title === `Shey's Craft Room` ||
          post.title === 'For Sale'
            ? window.innerWidth > 600
              ? 400
              : 200
            : 350,
        backgroundImage: getBackgroundImage(),
      }}
    >
      {
        <img
          style={{ display: 'none' }}
          src={post.image}
          alt={post.imageText}
        />
      }
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.3)',
        }}
      />
      <Grid container justifyContent='center'>
        <Grid item sm={12} justifyContent='center'>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3 },
              textAlign: 'center',
            }}
          >
            <Typography
              component='h2'
              variant='primary'
              color='inherit'
              gutterBottom
              sx={{
                mt:
                  post.title === 'About Me' ||
                  post.title === 'Custom Orders' ||
                  post.title === 'Gallery' ||
                  post.title === `Shey's Craft Room` ||
                  post.title === 'For Sale'
                    ? 1
                    : 20,
                fontSize: { xs: 45, md: 75 },
                mb: 0,
              }}
            >
              {post.title}
            </Typography>
            {getInsetImage()}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default MainFeaturedPost;
